import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ExternalLinkIcon } from 'assets/icons';
import { getIAMAvailableModules } from 'domains/catalog/CatalogIam.store';
import { UserRole } from 'domains/user';
import { getHasAccessToTechnicalLinks, notAuthorizedTab } from 'pages/CatalogPage/common/CatalogBanner/TabCommon';
import { theme } from 'styles';
import { Icon, LinkTabItem, Text } from 'UI';
import { getCondArrayItem, getData } from 'utils';

export const TabDocumentation = ({
  isIam,
  versionCode,
  userRights,
  technicalDocumentationVersionUrl,
}: {
  isIam: boolean;
  versionCode: string | undefined;
  userRights: UserRole[] | undefined;
  technicalDocumentationVersionUrl: string;
}): LinkTabItem[] => {
  const { t } = useTranslation();
  const label = t('catalog.parts.category.documentation', 'Documentation');
  const availableDataModule = getData(useSelector(getIAMAvailableModules));
  const handleTab = () => {
    return getHasAccessToTechnicalLinks({ isIam, versionCode, userRights }) //NOSONAR
      ? {
          key: 11,
          label: (
            <a href={technicalDocumentationVersionUrl} target={'_blank'} rel={'noreferrer'}>
              <Text type={'lead_text_white'} noWrap>
                {label}
                <Icon ml={5} size={14} IconComponent={ExternalLinkIcon} color={theme.color.white} />
              </Text>
            </a>
          ),
          link: 'EXTERNAL',
          staticWithColor: theme.color.grey25,
          dataCy: 'tab-technical-data',
        }
      : // for IAM car without rights is displayed blue tab
        notAuthorizedTab({
          key: 11,
          dataCy: 'tab-technical-data-no-access',
          label,
        });
  };
  // display only for IAM cars or for R/D cars for users R3_M with subscription
  return getCondArrayItem((isIam || availableDataModule) && handleTab());
};
